<div class="run-challenge-modal" *ngIf="!isSaved">
    <div class="run-challenge-modal-close">
        <i class="icon-edponline-Bop-071" (click)="close()"></i>
    </div>

    <div class="run-challenge-modal-image">
        <picture>
            <source [srcset]="challenge.type !== 'FESTIVAL'
                ? 'assets/images/run-challenge-modal-mobile-image.png'
                : 'assets/images/stella-images/festival-challenge-mobile.png'" media="(max-width: 576px)" />
            <img [srcset]="challenge.type !== 'FESTIVAL'
                ?'assets/images/run-challenge-modal-image.png'
                : 'assets/images/stella-images/festival-challenge.png'" alt="…" />
        </picture>
    </div>

    <div class="run-challenge-modal-container">
        <p class="run-challenge-modal-title">
            {{ "pt.edp.edponline.run.challenge.modal.title" | translate }}
        </p>

        <p
            class="run-challenge-modal-description"
            [innerHtml]="(challenge.type === 'FESTIVAL'
                ? 'pt.edp.edponline.run.challenge.modal.festival.description'
                : 'pt.edp.edponline.run.challenge.modal.description') | translate: { points: points }"
        ></p>

        <form [formGroup]="form" class="edp-form flex-fill d-flex flex-column w-100">
            <edp-select-list
                [options]="list"
                [placeholder]="(challenge.type === 'FESTIVAL'
                    ? 'pt.edp.edponline.run.challenge.modal.festival.dropdown.placeholder'
                    : 'pt.edp.edponline.run.challenge.modal.dropdown.placeholder') | translate"
                (nextOptions)="setSelectedOption($event)"
            ></edp-select-list>
            <div class="run-challenge-modal-details" *ngIf="!!selectedLocal">
                <div *ngIf="date">
                    <span>
                        <b>{{ "pt.edp.edponline.run.challenge.modal.date" | translate }}</b>
                    </span>
                    <span [innerHtml]="date"></span>
                </div>

                <div *ngIf="local">
                    <span>
                        <b>{{ "pt.edp.edponline.run.challenge.modal.local" | translate }}</b>
                    </span>
                    <span [innerHtml]="local"></span>
                </div>
            </div>

            <button class="btn btn-primary run-challenge-modal-btn" type="submit" (click)="submit()" [disabled]="!selectedLocal">
                {{ "pt.edp.edponline.run.challenge.modal.btn" | translate }}
            </button>
        </form>
    </div>
</div>

<div class="run-challenge-modal" *ngIf="!!isSaved" [ngClass]="{'saved': isSaved}">
    <div class="run-challenge-modal-close">
        <i class="icon-edponline-Bop-071 icon-dark" (click)="close()"></i>
    </div>

    <div class="run-challenge-modal-container run-challenge-modal-container-final">
        <i class="icon-edponline-Bop-072 success-icon"></i>

        <p class="run-challenge-modal-title">
            {{ "pt.edp.edponline.run.challenge.modal.contact" | translate }}
        </p>

        <p class="description" [innerHtml]="'pt.edp.edponline.run.challenge.modal.award' | translate"></p>
    </div>
</div>
